// Citatrutorna (blockquote) i hjälpartiklarna: ljusgul bakgrund med en mörkare kant till vänster, så att de sticker ut
// ur texten. Samma färger och mått i hjälpcentret och i editorn, så att rutan ser likadan ut när den skrivs.
export const HELP_CALLOUT_BACKGROUND = '#FFFCD5';
export const HELP_CALLOUT_BORDER = '#E7DCA4';
export const HELP_CALLOUT_PADDING = '14px 20px';

// Regeln för editorns innehåll (TinyMCE:s content_style). Full bredd istället för webbläsarens indrag, och ingen extra
// luft från styckena innanför rutan.
export const HELP_EDITOR_CONTENT_STYLE = `
  blockquote {
    margin: 16px 0;
    padding: ${HELP_CALLOUT_PADDING};
    background-color: ${HELP_CALLOUT_BACKGROUND};
    border-left: 5px solid ${HELP_CALLOUT_BORDER};
  }
  blockquote > :first-child { margin-top: 0; }
  blockquote > :last-child { margin-bottom: 0; }
`;
